export default function NotFound() {
    return(
        <>
            <h1>404 - Not found</h1>
        </>
    )
}